
import { useContext, useState } from "react"
import { formatDate, notify } from "../utils/utils"
import { AuthFetchHelpCenter } from "../services/api";
import { useModal } from "./useModal";
import { UserContext } from "../context/provider/UserProvider";


export const useCentroAyuda = () => {
    const { stateUser } = useContext(UserContext);
    const mensajeWebDefault = {
        uidCreacion: '',
        idRoom: '',
        comentario: '',
        codUsuarioReclamo: 0,
        codAccesoTipo: 2
    }
    const solucionDefault = {
        codUsuarioReclamo: 0,
        comentario: '',
        solucionado: true
    }

    const detalleReclamoDefault = [
        {
            codUsuarioReclamoInusual: 0,
            comentario: "",
            fechaHoraReclamo: '',
            fechaHoraCreacion: "",
            uIDCreacion: "",
            uIDAtencion: "",
            fechaHoraAtencion: "",
            comentarioAtencion: "",
            solucionado: false,
            codEstadoReclamo: 9,
            nomEstado: ""
        }
    ]

    const [ reclamos, setReclamos ] = useState([]);
    const [ detalleReclamo, setDetalleReclamo ] = useState(detalleReclamoDefault)
    const [ mensajesPorSala, setMensajesPorSala ] = useState([]);
    const [ mensajeWeb, setMensajeWeb ] = useState(mensajeWebDefault);
    const [ registroSolucion, setRegistroSolucion ] = useState(solucionDefault);

    const listarReclamos = async (FechaInicio, FechaFin) => {
        console.log('[listarReclamos] stateUser ',stateUser)
        try
        {
            const response = await AuthFetchHelpCenter(`/HelpCenter/allComplaints?`+ new URLSearchParams({
                UIDAccion: stateUser.uid,
                fechaInicio: formatDate(FechaInicio),
                fechaFin: formatDate(FechaFin)
            }));
            !response.isValid && notify(response.exceptions[0].description, 'error');
            if(response.isValid){
                setReclamos(response.content)
            }
        }
        catch(error){
            setReclamos([]);
            notify('Ocurrió un error en el servicio','error');
        }
    }

    const obtenerDetalleReclamo = async (codUsuarioReclamo) => {
        try{
            const response = await AuthFetchHelpCenter('/HelpCenter/complaint?'+ new URLSearchParams({
                CodUsuarioReclamo : codUsuarioReclamo
            }));
            !response.isValid && notify(response.exceptions[0].description, 'error'); 
            if(response.isValid){
                setDetalleReclamo(response.content);
            }
            else{
                setDetalleReclamo([])
            }
        }
        catch(error){
            setDetalleReclamo([]);
            notify('Ocurrió un error en el servicio','error');
        }
    }

    const obtenerMensajesPorSala = async (idRoom) => { //Listado del chat
        try{
            const response = await AuthFetchHelpCenter('/HelpCenter/allComplaintMessages/' + idRoom);
            !response.isValid && notify(response.exceptions[0].description, 'error'); 
            setMensajesPorSala(response.isValid ? response.content : []);
        }
        catch(error){
            setMensajesPorSala([]);
            notify('Ocurrió un error en el servicio','error');
        }
    }

    const iniciarAtencionReclamo = async (codUsuarioReclamo) => {
        try{
            const response = await AuthFetchHelpCenter('/HelpCenter/assignAdvisorToClaim',{
                method: 'PUT',
                body: JSON.stringify({
                    UIDAccion: stateUser.codUsuario,
                    CodUsuarioReclamo: codUsuarioReclamo,
                })
            })
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
            return response.isValid

        }
        catch(error){
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }
    
    const editarValorMensajeWeb = (key,value) => { // edita valor para responder en el chat (AC)
        setMensajeWeb(reclamo => {
            return {
                ...reclamo,
                [key]: value
            }
        });
    }

    const guardarSolucionReclamo = async () => {
        try{
            const response = await AuthFetchHelpCenter('/HelpCenter/resolveComplaint',{
                method:'PUT',
                body:JSON.stringify({
                    UIDAccion: stateUser.uid,
                    CodUsuarioReclamo: registroSolucion.codUsuarioReclamo,
                    Comentario: registroSolucion.comentario,
                    Solucionado: registroSolucion.solucionado
                })
            })
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error');
            return response.isValid
        }
        catch(error){
            notify('Ocurrió un error en el servicio','error');
            return false
        }
    }

    const editarValorRegistroSolucion = (key,value) => {
        setRegistroSolucion(solucion => {
            return {
                ...solucion,
                [key]: value
            }
        })
    }
    
    return{
        reclamos,
        listarReclamos,
        detalleReclamo,
        obtenerDetalleReclamo,
        mensajesPorSala,
        obtenerMensajesPorSala,
        mensajeWeb,
        editarValorMensajeWeb,
        registroSolucion,
        guardarSolucionReclamo,
        editarValorRegistroSolucion,
        iniciarAtencionReclamo,
    }
}